<template>
    <v-row>
       <v-col cols="12" class="pt-1">
           <v-expansion-panels
               v-model="panel"
               multiple
           >
               <v-expansion-panel>
                   <v-expansion-panel-header 
                       expand-icon="mdi-menu-down" 
                       class="px-3 py-0"
                   >
                       <h4 class="ml-2 d-flex justify-space-between align center custom-h4-heading">
                        Describe Segment Rule or Select Prompt*
                       </h4>
                   </v-expansion-panel-header>
                   <v-expansion-panel-content class="mt-4">
                       <v-row>
                           <v-col cols="12" class="text-align pt-0">
                               <v-btn 
                                class="cancel-btn prompt-btn-border"
                                v-track="'segment-prompt-btn'" 
                                @click="handleShowSuggestions()">
                                   <v-icon 
                                       dark 
                                       class = "pr-1 ml-n2"
                                   >
                                       mdi-cached
                                   </v-icon>
                                   SEGMENT PROMPTS
                               </v-btn>
                           </v-col>
                           <v-col 
                               cols="12" 
                               class="pt-1 px-3"
                           >
                           <div class="dropdown-textarea">
                            <v-textarea
                               dense
                               outlined
                               :rows="1"
                               auto-grow
                               append-icon="mdi-magnify"
                               label="Segment Rule*"
                               v-model.trim="userString"
                               class="search-account-pd-br mb-1"
                               :rules="[v => v.length == 1000 && 'You have reached the maximum amount of characters allowed']"
                               :maxlength="1000"
                               @input="enablePreview"
                               ref="textarea"
                           />
                           <div class="text-right mt-n6 ">
                           <span class="v-counter theme--light"> {{ userString.length ? messageLength.length : 0 }}/1000</span>
                           </div>
                           <v-menu
                                v-model="showMenu"
                                offset-y
                                attach
                                transition="scale-transition"
                                :close-on-click="true"
                                class="segment-prompts-dropdown"
                                v-track="'segment-prompt-options-menu'" 
                            >   
                                <v-list>
                                <v-list-item 
                                    @click="handleOptionClick(option)" 
                                    v-for="(option,index) in options" 
                                    :key="option"
                                    v-track="`switch-acount-to-${index}`"
                                    >
                                    <v-list-item-title>{{option}}</v-list-item-title>
                                </v-list-item>
                                </v-list>
                            </v-menu>
                           </div>
                           </v-col>
                           <v-col class="mb-4">
                               <v-btn
                                   v-track="'nlp-preview-rule-btn'"
                                   class="text-capitalize save-btn"
                                   :loading="loadingPreview"
                                   @click="previewCriteria()"
                                   :disabled="!validateGenerate || disablePreview ||loadingGenerate"
                               >
                                PREVIEW RULE
                               </v-btn>
                               
                               <v-btn v-if="showSaveButton"
                                   class="ml-4 text-capitalize save-btn"
                                   :loading="loadingGenerate"
                                   @click="saveQuery()"
                                   :disabled="!validateGenerate"
                                   :dark="validateGenerate"
                                   v-track="'generate-ai-criteria'"
                               >
                                  Save
                               </v-btn>
                               <v-btn v-else
                                   class="ml-4 text-capitalize save-btn black white--text "
                                   :loading="loadingGenerate"
                                   @click="generateQuery(true)"
                                   :disabled="!validateGenerate || disablePreview"
                                   v-track="'generate-ai-criteria'"
                               >
                                  Generate
                               </v-btn>
                           </v-col>
                       </v-row>
                   </v-expansion-panel-content>
               </v-expansion-panel>
               <v-expansion-panel>
                   <v-expansion-panel-header 
                       expand-icon="mdi-menu-down" 
                       class="px-3 py-0"
                   >
                       <h4 class="ml-2 d-flex justify-space-between align center custom-h4-heading">
                           Preview Segment Rule
                       </h4>
                       <v-progress-linear
                       v-if="loadingGenerate || loadingPreview"
                        rounded
                        indeterminate
                        absolute
                        top 
                        ></v-progress-linear>
                   </v-expansion-panel-header>
                   <v-expansion-panel-content>
                       <v-row>
                           <v-col 
                               cols="12" 
                               class="pt-1 pl-1"
                           >
                           <ai-rule-preview :aiRules="allAifilters" :conditionText="segment.match_all"></ai-rule-preview>
                           </v-col>  
                       </v-row>
                   </v-expansion-panel-content>
               </v-expansion-panel>
           </v-expansion-panels>
       </v-col>
   </v-row>
</template>
<script>
import axios from 'axios';
import { $nlp } from '@/services'
import aiRulePreview from './rulePreview.vue'
import { 
        convertObjectToString,
        checkApiCall,
        sortOptionalFilters 
    } from '../scripts/CommonFunction.js'
    
   export default {
       name:'segmentAIInput',
       components:{
           aiRulePreview
       },
       data(){
           return{
               panel:[0,0],
               userString:'',
               allAifilters : [],
               aiFilterId:0,
               loadingGenerate: false,
               loadingPreview:false,
               disablePreview: true,
               showMenu:false,
               options: [
                'New subscribers within the last 30 days',
                'Subscribers who have not clicked or opened an email in the last 30 days',
                'Subscribers who have not purchased in the last 30 days',
                'Contacts whose domain is gmail.com',
                'Subscribers who have purchased at least 3 times in the last 90 days',
                'Contacts who have received atleast 5 emails on the month of May',
                'Subscribers who have made more than $1000 in purchases over the last 120 days',
                'Subscribers whose Lifetime value is more than $1000',
                'Subscribers who have clicked more than once in the last 30 days'
               ],
               keywords:[
                'not clicked','opened', 'not clicked or opened', 'purchased', 'purchases' 
               ],
                highlightedText: ''
           }
       },
       computed:{
           addAiFilter : {
               get () { 
                   return this.$store.state.ui.drawer.right.addAiFilter 
               },
               cache:false
           },
           increaseTotalCount : {
               get () { 
                   return this.$store.state.ui.drawer.right.increaseTotalCount 
               },
               cache:false
           },
           decreaseTotalCount : {
               get () { 
                   return this.$store.state.ui.drawer.right.decreaseTotalCount 
               },
               cache:false
           },
           rule : {
               get () { 
                   return this.$store.state.ui.drawer.right.rule 
               },
               cache:false
           },
           addFilterId:{
               get () { 
                   return this.$store.state.ui.drawer.right.addFilterId 
               },
               cache:false
           },
           segment:{
               get () { 
                   return this.$store.state.ui.drawer.right.segment 
               },
               cache:false
           },
           segmentData:{
               get () { 
                   return this.$store.state.ui.drawer.right.segmentData 
               },
               cache:false
           },
           validateGenerate () {
            if(this.userString.trim()){
               this.enablePreview()
               return true
            }
            return false
           },
           showSaveButton:{
            get() {
                let isLoaded = false;
                for(let i=0;i<this.allAifilters.length;i++){
                 isLoaded = checkApiCall(this.allAifilters[i].allFilters[0].children,this.allAifilters[i]) ||this.allAifilters[i].childLoaded
                if(!isLoaded) break;
              }
              return isLoaded
            },
            cache: false
           },
           messageLength:{
            get(){
                return this.userString.trim()
           }
          }

       },
       methods:{
           previewCriteria(addIntoRules=false){
               this.removeCriteriaFromRule()
               this.allAifilters = []
               this.disablePreview = true;
               this.segment.aiUsed = true;
               this.$set(this.segment,'aiQuery',this.userString)
               if(addIntoRules)
                    this.loadingGenerate = true;
                else
                    this.loadingPreview = true;  
                $nlp.fetch({input : this.userString}).then(response => {
                   if(response.data.segment_rules_attributes.segment_filters_attributes){
                       let criterias = response.data.segment_rules_attributes.segment_filters_attributes
                       if(response.data.segment_rules_attributes.filter){
                           if(response.data.segment_rules_attributes.filter == 'and')
                               this.segment.match_all = true;
                           else
                               this.segment.match_all = false;
                       }
                        if(addIntoRules)
                            this.removeEmptyCriteria();
                        for(let i=0 ; i< criterias.length ; i++){
                            if(criterias[i].filters){
                                if(criterias[i].filters.list && (criterias[i].filters.list.brand && typeof(criterias[i].filters.list.brand) == 'object')){
                                    criterias[i].filters.list.brand.notConvertabelString = true
                                }
                                if(criterias[i].filters.list && (criterias[i].filters.list.list_name && typeof(criterias[i].filters.list.list_name) == 'object')){
                                    criterias[i].filters.list.list_name.notConvertabelString = true
                                }
                                if(criterias[i].filters.tag && typeof(criterias[i].filters.tag) == 'object'){
                                    criterias[i].filters.tag.notConvertabelString = true
                                }
                                if(criterias[i].filters.journey && typeof(criterias[i].filters.journey) == 'object'){
                                    criterias[i].filters.journey.notConvertabelString = true
                                }
                                if(criterias[i].filters.segment && typeof(criterias[i].filters.segment) == 'object'){
                                    criterias[i].filters.segment.notConvertabelString = true
                                }
                                if(criterias[i].filters.form && typeof(criterias[i].filters.form) == 'object'){
                                    criterias[i].filters.form.notConvertabelString = true
                                }
                                if(criterias[i].filters.sql_query && typeof(criterias[i].filters.sql_query) == 'object'){
                                    criterias[i].filters.sql_query.notConvertabelString = true
                                }
                                if(criterias[i].filters.relational_table && typeof(criterias[i].filters.relational_table) == 'object'){
                                    criterias[i].filters.relational_table.notConvertabelString = true
                                }
                                if(criterias[i].filters.funnel_name && typeof(criterias[i].filters.funnel_name) == 'object'){
                                    criterias[i].filters.funnel_name.notConvertabelString = true
                                }
                                if(criterias[i].filters.site_name && typeof(criterias[i].filters.site_name) == 'object'){
                                    criterias[i].filters.site_name.notConvertabelString = true
                                }
                                
                                if(criterias[i].filters && criterias[i].filters.optional_filters){
                                    if(criterias[i].filters.relational_table){
                                        criterias[i].filters.relational_table.notConvertabelString = true
                                    }
                                    let optionalFilters = criterias[i].filters.optional_filters
                                    for (const key in optionalFilters) {
                                        for(const val in optionalFilters[key]){
                                            if(typeof optionalFilters[key][val] === 'object'){
                                                optionalFilters[key][val].notConvertabelString = true;
                                            }
                                        }
                                    }
                                    criterias[i].filters.optional_filters = optionalFilters
                                }
                            
                                if(criterias[i].filters.optional_filters){
                                    criterias[i].filters.optional_filters = sortOptionalFilters(criterias[i].filters.optional_filters)
                                }
                            }
                           let filter = convertObjectToString(criterias[i])
                           
                           filter = this.addAiFilter(filter)
                           if(addIntoRules){
                               filter.isHidden = false
                               this.increaseTotalCount();
                           }else{
                               filter.isHidden = true
                          }
                          filter.aiGenrated = true

                          filter =  this.addFilterId(filter);
                           
                           if(!addIntoRules)
                               this.allAifilters.push(filter)

                            this.rule.push(filter)
                       }

                       if(addIntoRules){
                            this.segmentData.built_with_ai = true;
                            this.$store.commit('ui/drawer.right', {
                               show: false,
                            })
                        }
                       
                   }
                   else if(response.data.segment_rules_attributes.error){
                        this.savePropmt()
                       this.$store.commit('ui/snackbar',{
                           message : response.data.segment_rules_attributes.error,
                           type: 'error'
                       })
                   }
                    this.panel= [0,1]

               }).catch(err=>{
                    this.savePropmt()
               })
               .finally(()=>{
                    this.loadingPreview = false;
                   this.loadingGenerate = false
               })
           },
           saveQuery(){
               this.removeEmptyCriteria();
               this.rule.forEach(element => {
                   if(element.aiGenrated && element.isHidden){
                        delete element.aiGenrated
                        delete element.childLoaded 
                        element.isHidden = false
                       this.increaseTotalCount();
                   }
               });
               this.segmentData.built_with_ai = true;
               this.segment.aiQuery = this.userString;
               this.$store.commit('ui/drawer.right', {
                   show: false,
               })

           },
           removeEmptyCriteria(){
               for(let i=this.rule.length -1 ; i > -1 ;i--){
                   if(!this.rule[i].allFilters[0].children || !this.rule[i].allFilters[0].children.default){
                       this.decreaseTotalCount();
                       this.rule.splice(i,1)
                   }
               }
           },
           removeCriteriaFromRule(){
               this.allAifilters.forEach(element => {
                   let index =  this.rule.findIndex(x=>x.filterId == element.filterId)
                   if(index != -1){
                       this.rule.splice(index,1)
                   }
                   
               });
           },
           generateQuery(val){
               this.loadingGenerate = true;
               this.previewCriteria(val)
           },
           enablePreview(){
               this.disablePreview = false
           },
           handleShowSuggestions(){
            this.showMenu = !this.showMenu
           },
            handleOptionClick(option) {
                this.userString = option;
                this.menu = false;
            },
            //in case we want to highlight the text mentioned in the keywords
            highlightText(text) { 
                this.keywords.forEach(keyword => {
                    const regex = new RegExp('\\b' + keyword + '\\b', 'gi');
                    text = text.replace(regex, `<span class="highlight-text">${keyword}</span>`);
                });
                return text;
            },
            //in case we want to highlight the text mentioned in the keywords in the textarea
            updateHighlightedText() {
                let newText = this.userString;
                this.keywords.forEach(keyword => {
                    const regex = new RegExp('\\b' + keyword + '\\b', 'gi');
                    newText = newText.replace(regex, `<span class="highlight-text">${keyword}</span>`);
                });
                this.highlightedText = newText;
            },
            savePropmt(){
                let payload = {
                    input: this.userString,
                    result: "To be review",
                    account_id: this.$store.getters['auth/account'].id 
                }
                $nlp.storePrompts(payload)
            }
        },
    watch: {
        userString() {
            this.updateHighlightedText();
    }
  }


   }
</script>

<style scoped lang="scss">
.text-align{
   text-align: end;
}
.cancel-btn{
   border: 1px solid;
   background-color: #fff !important;
   box-shadow: none;
}
.cancel-btn .save-btn{
   font-weight: 700;
   font-size: 14px;
   line-height: 24px;
   text-transform: uppercase !important;
}   
.prompt-btn-border{
    border: 1px solid #00000061;
}
::v-deep .v-btn__content{
    letter-spacing: 0.55px;
    line-height: 24px;
    text-transform: uppercase !important;
}
.v-expansion-panel--active:not(:first-child), .v-expansion-panel--active + .v-expansion-panel {
    margin-top: 1px;
}
.v-text-field.v-text-field--enclosed .v-text-field__details{
    margin-top: 5px!important;
}
::v-deep .v-text-field__details{
    margin-top: 5px !important;
    padding-right: 0px !important;
}
::v-deep textarea{
    margin-top: 0px!important;
}
::v-deep .v-textarea textarea{
    line-height: 24px !important;
    color: rgba(0, 0, 0, 0.60) !important;
    font-weight: 400;
    letter-spacing: 0.15px;
    padding: 18px 0;
}
.custom-h4-heading{
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.55px;
}
.align-item-baseline{
    align-items: baseline;
}
.v-expansion-panel-header{
    min-height: 36px;
}
.v-expansion-panel--active > .v-expansion-panel-header {
    min-height: 36px;
}
.v-expansion-panels .v-expansion-panel{
    margin-top: 2px;
    border-radius: inherit;
}
.dropdown-textarea {
    position: relative;
}
::v-deep .v-menu .v-menu__content {
    max-width: none;
    width: 809px;
    top: auto !important;
    z-index: 9999 !important;
    max-height: 240px;
    bottom: calc(0px - 221px)!important;
    background-color: white;
    box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12), 0px 2px 4px 0px rgba(0, 0, 0, 0.20);
}
.v-menu__content .v-list {
    padding: 0;
    .v-list-item {
        padding: 0 12px;
    }
}
.v-list-item--link {
    &:hover{
        background: rgb(235 235 235)!important;
    }
}
::v-deep .v-list-item__title {
    letter-spacing: 0.15px;
    .highlight-text {
    font-weight: 600 !important;
}}
::v-deep .v-input__append-inner{
    margin-top: 18px !important;
}
::v-deep .v-label {
    top: 19px !important;
}
::v-deep .v-text-field--outlined.v-input--dense .v-label--active {
    transform: translateY(-27px) scale(0.75)!important;
}

</style>